import React from 'react';
import PortfolioBlock from "./PortfolioBlock";
import {Box} from "@mui/material";
import {info} from "../../info/Info";
import Style from './Portfolio.module.scss';

export default function Portfolio({innerRef}) {
    return (
        <Box ref={innerRef} className={Style.container} id={'portfolio'}>
            <Box className={Style.header}>
                <h2 className={Style.title}>Portfolio</h2>
                <p className={Style.subtitle}>Self development, just-for-fun projects.</p>
            </Box>
            <Box component={'ul'} className={Style.projectList}>
                {info.portfolio.map((project, index) => (
                    <Box key={index} component={'li'} className={Style.projectItem}>
                        <PortfolioBlock 
                            image={project.image} 
                            live={project.live} 
                            source={project.source} 
                            title={project.title} 
                            description={project.description} 
                        />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
